import { makeStyles } from "@material-ui/core";

const useNewReportStyles = makeStyles(theme => ({
    root: {
        // display: "flex",
        justifyContent: "center",
        marginTop: "3rem",
        marginBottom: theme.spacing(1.5)
    },
    label: {
        fontFamily: "OpenSans",
        fontWeight: "bold",
        fontSize: "0.85rem",
        marginBottom: theme.spacing(1)
    },
    button: {
        margin: 5
    },
    button1: {
        // marginLeft: "auto",
        height: 37,
        margin: 5,
        backgroundColor: "#4caf50",
        "&:hover": {
            backgroundColor: "#388e3c"
        }
    },
    buttonLabel: {
        fontFamily: "OpenSans",
        fontWeight: 400,
        fontSize: "0.92rem"
    },
    previewTitle: {
        margin: "0px 18px",
        borderBottom: "1px solid #ccc",
        padding: "10px 0",
        fontFamily: 'OpenSans',
        fontWeight: 600,
        fontSize: "0.98rem",
        display: "flex",
        alignItems: "center",
    },
    text: {
        margin: "0px 18px",
        padding: "10px 0",
        fontFamily: 'OpenSans',
        fontSize: "0.85rem"
    },
    titleHead: {
        fontFamily: 'OpenSansSemiBold',
        fontSize: "1.3rem",
    },
    titleText: {
        marginTop: 3,
        color: "#999",
        fontFamily: 'OpenSans',
        fontSize: "0.85rem"
    },
    rootContainer: {
        // display: "table",
        display: "flex",
        margin: "auto",
        marginTop: "5rem"
    },
    titleCont: {
        padding: "0px 18px",
        display: "flex",
        alignItems: "center"
    },
    date: {
        fontFamily: 'OpenSansSemiBold',
        fontSize: "0.85rem",
        paddingRight: 5
    },
    previewTableHeaderCell: {
        padding: 8,
        border: "1px solid #ccc",
        fontFamily: 'OpenSansSemiBold',
        fontSize: "0.85rem",
        position: "sticky",
        top: 0,
        backgroundColor: "#fff"
    },
    previewTableCell: {
        padding: 8,
        fontFamily: 'OpenSans',
        fontSize: "0.85rem",
        border: "1px solid #ccc",
        '&:nth-of-type(even)': {
            // backgroundColor: "#f5f9fc",
        },
        '&:nth-of-type(odd)': {
            // backgroundColor: "#fff",
        }
    },
    closeButton: {
        marginLeft: "auto",
        margin: 0,
        padding: 5
    }

}))

export default useNewReportStyles;